import React from "react";
import { CreateEmailCycleDrawerContent } from "./contents/CreateEmailCycleDrawerContent";
import { ScheduleType } from "../../stores/CreateEmailCycleStore";
import { NonDismissibleDrawer } from "../../../../components/drawer/NonDismissibleDrawer";

interface CreateEmailCycleDrawerProps {
  open: boolean;
  onClose: VoidFunction;
  onScheduleEmail: (scheduleType: ScheduleType) => void;
}

const CREATE_EMAIL_CYCLE_DRAWER_WIDTH = "1024px";

export const CreateEmailCycleDrawer: React.FC<CreateEmailCycleDrawerProps> = ({
  open,
  onClose,
  onScheduleEmail,
}) => {
  return (
    <NonDismissibleDrawer
      open={open}
      anchor="right"
      slotProps={{
        paper: {
          sx: {
            width: "100%",
            maxWidth: CREATE_EMAIL_CYCLE_DRAWER_WIDTH,
          },
        },
      }}
      onClose={onClose}
    >
      <CreateEmailCycleDrawerContent
        onClose={onClose}
        onScheduleEmail={onScheduleEmail}
      />
    </NonDismissibleDrawer>
  );
};
